
import { getLang } from "@/plugins/env"
import { trackFooterClick } from "@/utils/track"
export default {
  name: "Bottom",
  // serverCacheKey: _ => {
  //   return `${getLang()}_PageFooter`
  // },
  data() {
    return {
      lang: this.$i18n.locale,
      // wellcomeList: [
      //   {
      //     name: "ourStory",
      //     url_zh_HK: this.$t("footer.ourStoryLink"),
      //     url_en_US: this.$t("footer.ourStoryLink")
      //   },
      //   {
      //     name: "purchaseGuarantee",
      //     url_zh_HK: this.$t("footer.purchaseGuaranteeLink"),
      //     url_en_US: this.$t("footer.purchaseGuaranteeLink")
      //   },
      //   {
      //     name: "storeLocator",
      //     url_zh_HK: this.$t("footer.storeLocatorLink"),
      //     url_en_US: this.$t("footer.storeLocatorLink")
      //   },
      //   {
      //     name: "careers",
      //     url_zh_HK: this.$t("footer.careersLink"),
      //     url_en_US: this.$t("footer.careersLink")
      //   }
      // ]
      wellcomeList: [
        {
          name: "ourStory",
          url_zh_HK: this.$t("footer.ourStoryLink"),
          url_en_US: this.$t("footer.ourStoryLink")
        },
        {
          name: "findAstore",
          url_zh_HK: this.$t("footer.storeLocatorLink"),
          url_en_US: this.$t("footer.storeLocatorLink")
        },
        {
          name: "joinIsAsAnEmployee",
          url_zh_HK: this.$t("footer.joinIsAsAnEmployeeLink"),
          url_en_US: this.$t("footer.joinIsAsAnEmployeeLink")
        },
        {
          name: "joinUsaFranchise",
          url_zh_HK: this.$t("footer.joinUsaFranchiseLink"),
          url_en_US: this.$t("footer.joinUsaFranchiseLink")
        },
        {
          name: "orderCashVoucher",
          url_zh_HK: this.$t("footer.orderCashVoucherLink"),
          url_en_US: this.$t("footer.orderCashVoucherLink")
        },
        {
          name: "corporateSocialResponsibility",
          url_zh_HK: this.$t("footer.corporateSocialResponsibilityLink"),
          url_en_US: this.$t("footer.corporateSocialResponsibilityLink")
        },
        {
          name: "adRequests",
          url_zh_HK: this.$t("footer.adRequestsLink"),
          url_en_US: this.$t("footer.adRequestsLink")
        }
      ]
    }
  },
  computed: {},
  methods: {
    goDfiPage() {
      if (this.lang === "zh_HK") {
        window.open("https://www.dfiretailgroup.com/zh-HK")
      } else {
        window.open("https://www.dfiretailgroup.com/en")
      }
    },
    goPreTerms() {
      return this.$t("footer.preTermsAndConditionsLink")
    },
    goTerms() {
      return this.$t("footer.termsAndConditionsLink")
    },
    goPolicy() {
      return this.$t("footer.privacyPolicyLink")
    },
    goPurchaseGuarantee() {
      const link = this.$t("footer.purchaseGuaranteeLink")
      window.open(link)
    },

    goRegistrationCertificates() {
      const link = document.createElement("a")
      link.href = this.$t("footer.registrationCertificatesLink")
      link.download = "Registration Certificates of Macau Takeaway Activities.pdf"
      link.target = "_blank"
      link.click()
    },
    handleJump(type) {
      let name = ""
      switch (type) {
        case "email":
          name = "Contact us email"
          location.href = "mailto:" + this.$t("footer.emailLink")
          break
        case "terms":
          name = "Terms & Conditions"
          this.goTerms()
          break
        case "policy":
          name = "Privacy Policy"
          this.goPolicy()
          break
        case "dfi":
          name = "DFI Retail Group"
          this.goDfiPage()
          break
        case "purchaseGuarantee":
          name = "DFI Retail Group"
          this.goPurchaseGuarantee()
          break
        case "registrationCertificates":
          name = "DFI Retail Group"
          this.goRegistrationCertificates()
          break
        case "emailCateringOrder":
          location.href = "mailto:" + this.$t("footer.b2bCateringOrdersEnquiresLink")
          break
        default:
          break
      }
      this.trackFooterClick(name)
    },
    trackFooterClick,
    goItemLink(item) {
      const lang = this.$i18n.locale
      const url = item[`url_${lang}`]
      return url
    },
    openDownladStore(url) {
      window.open(url)
    }
  }
}
